import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaUsers,
  FaHistory,
  FaAward,
  FaShieldAlt,
  FaGlobe,
  FaChartLine,
  FaCog,
  FaGraduationCap,
  FaCertificate,
  FaLinkedin,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaBuilding,
  FaTrophy,
  FaStar,
  FaQuoteLeft,
  FaArrowRight,
  FaDownload,
  FaEye,
  FaBullseye,
  FaClock,
} from "react-icons/fa";
import "./ProfilePage.css";

const ProfilePage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Dynamic calculation of years since company founding
  const yearsInBusiness = new Date().getFullYear() - 1989;
  
  const teamMembers = [
    {
      name: "Ing. Peter Novák",
      position: "Riaditeľ spoločnosti",
      description:
        "Zakladateľ a vizionár spoločnosti s 20-ročnými skúsenosťami v IT sektore.",
      experience: "20+ rokov",
      specialization: "Strategické riadenie, Business development",
      education: "VŠ technická, MBA",
      certifications: ["PMP", "ITIL Master"],
      email: "peter.novak@inver.sk",
      linkedin: "#",
    },
    {
      name: "Mgr. Mária Svobodová",
      position: "CTO - Technický riaditeľ",
      description: "Expertka na kybernetickú bezpečnosť a cloud technológie.",
      experience: `${yearsInBusiness}+ rokov`,
      specialization: "Kybernetická bezpečnosť, Cloud architektúra",
      education: "FEI STU, Security Management",
      certifications: ["CISSP", "AWS Solutions Architect", "CISSP"],
      email: "maria.svobodova@inver.sk",
      linkedin: "#",
    },
    {
      name: "Ing. Tomáš Krejčí",
      position: "Vedúci vývoja",
      description:
        "Lead developer s expertízou v moderných web technológiách a databázach.",
      experience: "12+ rokov",
      specialization: "Full-stack development, Databázy",
      education: "FIIT STU, Software Engineering",
      certifications: ["Oracle Certified", "Microsoft Azure Developer"],
      email: "tomas.krejci@inver.sk",
      linkedin: "#",
    },
    {
      name: "Bc. Anna Horáková",
      position: "Manažér projektov",
      description:
        "Zodpovedná za koordináciu projektov a komunikáciu s klientmi.",
      experience: "8+ rokov",
      specialization: "Project management, Client relations",
      education: "FPV UKF, Project Management",
      certifications: ["PMP", "Agile Certified", "PRINCE2"],
      email: "anna.horakova@inver.sk",
      linkedin: "#",
    },
    {
      name: "Ing. Lukáš Dvorský",
      position: "IT Security špecialista",
      description: "Expert na penetračné testovanie a incident response.",
      experience: "10+ rokov",
      specialization: "Penetration testing, Incident response",
      education: "FEI STU, Cybersecurity",
      certifications: ["CEH", "OSCP", "GCIH"],
      email: "lukas.dvorsky@inver.sk",
      linkedin: "#",
    },
    {
      name: "Mgr. Katarína Nováková",
      position: "Obchodný riaditeľ",
      description: "Zodpovedná za obchodné aktivity a rozvoj nových trhov.",
      experience: "12+ rokov",
      specialization: "Sales management, Business development",
      education: "NHF EU, Marketing",
      certifications: ["Sales Professional", "Digital Marketing"],
      email: "katarina.novakova@inver.sk",
      linkedin: "#",
    },
  ];

  const achievements = [
    {
      icon: FaTrophy,
      title: "IT Company of the Year 2024",
      description: "Ocenenie za najlepšiu IT spoločnosť roku na Slovensku",
      year: "2024",
    },
    {
      icon: FaShieldAlt,
      title: "Cybersecurity Excellence Award",
      description:
        "Uznanie za vynikajúce služby v oblasti kybernetickej bezpečnosti",
      year: "2023",
    },
    {
      icon: FaUsers,
      title: "Best Employer 2023",
      description: "Ocenenie za najlepšieho zamestnávateľa v IT sektore",
      year: "2023",
    },
    {
      icon: FaGlobe,
      title: "Innovation in Cloud Services",
      description: "Inovácia roka za cloud riešenia pre malé a stredné podniky",
      year: "2022",
    },
  ];

  const stats = [
    { number: `${yearsInBusiness}+`, label: "Rokov na trhu", icon: FaCalendarAlt },
    { number: "500+", label: "Spokojných klientov", icon: FaUsers },
    { number: "24h", label: "Doba odozvy servis", icon: FaClock },
    { number: "100%", label: "Zákazkové riešenia", icon: FaTrophy },
  ];

  const mission = {
    vision:
      "Našou víziou je byť dlhodobým a spoľahlivým partnerom v oblasti digitalizácie podnikania. Už od svojho vzniku v roku 1989 a transformácie na spoločnosť s ručením obmedzeným v roku 1993 budujeme renomé firmy, ktorá spája odbornosť, inovatívne myslenie a rýchlu implementáciu riešení. Usilujeme sa pomáhať podnikom efektívne prechádzať do digitálneho prostredia, aby ich informačné systémy boli pružné, moderné a presne prispôsobené ich potrebám.",
    mission:
      "Medzi naše hlavné náplne činnosti patrí vývoj informačných systémov na mieru, zabezpečenie hardwarového pozadia pre jeho beh, predaj hardware podľa požiadaviek zákazníka, webhostingové služby a špeciálne služby podľa potreby zákazníkov. Okrem týchto služieb poskytujeme konzultačné služby, poradenské služby, spracovanie analýz a služby spojené s nábehom IS u zákazníka a jeho ďalším rozvojom.",
    values:
      "Firma INVER je počtom ľudí menšia, dynamická firma ktorá je vďaka tomu schopná veľmi promptne reagovať na nadštandardné požiadavky zákazníkov a zameriava sa najmä na región Košíc a východného Slovenska. Disponujeme vlastným servisným oddelením, ktoré je schopné v rámci východného Slovenska zasahovať spravidla do 24 hodín od nahlásenia poruchy.",
  };

  return (
    <div className="profile-page">
      {/* Hero Section */}
      <section className="profile-hero">
        <div className="container">
          <h1>O spoločnosti INVER s.r.o.</h1>
        </div>
        <div className="hero-stats">
          {stats.map((stat, index) => (
            <div key={index} className="stat">
              <div className="stat-icon">
                <stat.icon />
              </div>
              <span className="stat-number">{stat.number}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
      </section>


    </div>
  );
};

export default ProfilePage;
